import { createContext, ReactElement } from 'react';
import { ContentKeys, defaultGlobalContent } from './default-global-content';

interface GlobalContentItem {
  [key: string]: string;
}

interface GlobalContentContext {
  content: GlobalContentItem;
  lookupContent: (key: string) => string;
  isLoading: boolean;
}

export const GlobalContentContext = createContext({
  content: {} as GlobalContentItem,
  lookupContent: (key: string) => key,
  isLoading: false,
} as GlobalContentContext);

export function GlobalContentProvider({
  children,
}: {
  children: JSX.Element;
}): ReactElement<GlobalContentContext> {
  const lookupContent = (key: ContentKeys): string =>
    defaultGlobalContent[key] ?? `Missing content for key: ${key}`;

  return (
    <GlobalContentContext.Provider
      value={{
        content: defaultGlobalContent as GlobalContentItem,
        lookupContent,
        isLoading: false,
      }}
    >
      {children}
    </GlobalContentContext.Provider>
  );
}

GlobalContentProvider.displayName = 'GlobalContentProvider';
export default GlobalContentProvider;
